module.exports = __webpack_public_path__ + "media/images/logos/Sunway-University-0bec07597f6ead87b59fed5ceb92173b.svg";